// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { UploadError } from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import addToWishList, {
    AddToWishListParameter,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import loadWishListIfNeeded from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import setAllWishListLinesIsSelected from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetAllWishListLinesIsSelected";
import setEditingSortOrder from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetEditingSortOrder";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import translate from "@insite/client-framework/Translate";
import { ProductDto, WishListModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import OrderUpload, { OrderUploadStyles } from "@insite/content-library/Components/OrderUpload"; bunzl custom code changed import
import OrderUploadErrorsModal, {
    OrderUploadErrorsModalStyles,
} from "@insite/content-library/Components/OrderUploadErrorsModal";
// import ProductSelector, { ProductSelectorStyles } from "@insite/content-library/Components/ProductSelector"; // Starter Custom Code
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import Search from "@insite/mobius/Icons/Search";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import OverflowMenu, { OverflowMenuProps } from "@insite/mobius/OverflowMenu";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import React, { ChangeEvent, useCallback, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */

import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import Upload from "@store/Library/Components/Toolkit/Icons/Upload";
import SelectInline, { SelectInlineStyles } from "@store/Library/Components/Toolkit/SelectInline";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import ProductSelector, { ProductSelectorStyles } from "@store/Overrides/Components/ProductSelector";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

// Store Custom Code
import OrderUpload, { OrderUploadStyles } from "@store/Overrides/Components/OrderUpload";

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
    wishListDataView: getWishListState(state, state.pages.myListDetails.wishListId),
    wishListLinesDataView: getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter),
    loadWishListLinesParameter: state.pages.myListDetails.loadWishListLinesParameter,
    selectedWishListLineIds: state.pages.myListDetails.selectedWishListLineIds,
    editingSortOrder: state.pages.myListDetails.editingSortOrder,
});

const mapDispatchToProps = {
    updateLoadWishListLinesParameter,
    loadWishListIfNeeded,
    loadWishListLines,
    setAllWishListLinesIsSelected,
    addToWishList: makeHandlerChainAwaitable<AddToWishListParameter, WishListModel>(addToWishList),
    setEditingSortOrder,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface MyListsDetailsOptionsStyles {
    wrapper?: InjectableCss;
    leftColumnWrapper?: InjectableCss;
    rightColumnWrapper?: InjectableCss;
    container?: GridContainerProps;
    selectAllGridItem?: GridItemProps;
    selectAll?: CheckboxProps;
    editSortOrder?: CheckboxProps;
    searchGridItem?: GridItemProps;
    addItemsGridItem?: GridItemProps;
    addItemsLink?: LinkPresentationProps;
    addItemsGridContainer?: GridContainerProps;
    productSelectorGridItem?: GridItemProps;
    productSelectorStyles?: ProductSelectorStyles;
    uploadItemsGridItem?: GridItemProps;
    uploadItemsLink?: LinkPresentationProps;
    uploadItemsModal?: ModalPresentationProps;
    orderUploadStyles?: OrderUploadStyles;
    orderUploadErrorsModalStyles?: OrderUploadErrorsModalStyles;
    search?: TextFieldProps;
    sortByGridItem?: GridItemProps;
    sortByOverflowMenu?: OverflowMenuProps;
    sortByClickable?: ClickablePresentationProps;
    selectedSortByClickable?: ClickablePresentationProps;
    closeAddItemsToList?: IconProps;
    // Starter Custom Code
    addItemsAccordion?: AccordionPresentationProps;
    sortByWrapper?: InjectableCss;
    sortBySelectInline?: SelectInlineStyles;
    // Store Custom Code
    orderUploadGridItem?: GridItemProps;
}

export const myListsDetailsOptionsStyles: MyListsDetailsOptionsStyles = {
    // Store Custom Code - >
    orderUploadGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    // bunzl custom code <--

    wrapper: {
        css: css`
            ${x => spacingStyles(null, x.theme.design.typography.spacing.large)};
        `,
    },
    addItemsAccordion: {
        css: css`
            ${x => spacingStyles(null, x.theme.design.typography.spacing.larger)};
        `,
    },
    uploadItemsLink: mergeProps<MyListsDetailsOptionsStyles["uploadItemsLink"]>(linkGetActionLinkProps(Upload), {
        css: css`
            display: block;
            margin-bottom: ${pxToRem(20)};
        `,
    }),
    searchGridItem: { width: [12, 12, 7, 7, 7] },
    uploadItemsModal: { sizeVariant: "large" },
    search: { iconProps: { src: Search } },
    sortByWrapper: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
};

const styles = myListsDetailsOptionsStyles;

const MyListsDetailsOptions = ({
    id,
    wishListSettings,
    wishListDataView,
    wishListLinesDataView,
    loadWishListLinesParameter,
    selectedWishListLineIds,
    editingSortOrder,
    updateLoadWishListLinesParameter,
    loadWishListIfNeeded,
    loadWishListLines,
    setAllWishListLinesIsSelected,
    addToWishList,
    setEditingSortOrder,
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const [query, setQuery] = useState(loadWishListLinesParameter.query || ""); // Starter Custom Code
    const [addItemsToListIsOpen, setAddItemsToListIsOpen] = useState(false);
    const [uploadItemsModalIsOpen, setUploadItemsModalIsOpen] = useState(false);

    useEffect(() => {
        setQuery("");
    }, []);

    const debouncedSearch = useCallback(
        debounce((query: string) => {
            if (!wishListDataView.value) {
                return;
            }

            updateLoadWishListLinesParameter({ query });
            loadWishListLines();
        }, 200),
        [wishListDataView],
    );

    if (!wishListDataView.value || !wishListSettings) {
        return null;
    }

    const wishList = wishListDataView.value;

    const searchChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const newQuery = event.target.value || "";
        setQuery(newQuery);
        debouncedSearch(newQuery);
    };

    const sortByChangeHandler = (sortBy: string) => {
        // Store Custom Code - last sortBy to be saved in localStorage
        localStorage.setItem("wishListDetailSortBy", sortBy);
        setEditingSortOrder({ editingSortOrder: false });
        updateLoadWishListLinesParameter({ sort: sortBy });
        loadWishListLines();
    };

    const isAllSelected =
        wishListLinesDataView.value &&
        wishListLinesDataView.value.length > 0 &&
        wishListLinesDataView.value.every(o => selectedWishListLineIds.indexOf(o.id) >= 0);

    const selectAllChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        const allWishListLineIds = value ? wishListLinesDataView?.value?.map(o => o.id) : undefined;
        setAllWishListLinesIsSelected({ isSelected: value, wishListLineIds: allWishListLineIds });
    };

    const editingSortOrderChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        setEditingSortOrder({ editingSortOrder: value });
    };

    const addItemsToListClickHandler = () => {
        setAddItemsToListIsOpen(!addItemsToListIsOpen); // Starter Custom Code
    };

    const selectProductHandler = async (productInfo: ProductInfo) => {
        await addToWishList({ productInfos: [productInfo], selectedWishList: wishList });
        toasterContext.addToast({ body: translate("Item Added"), messageType: "success" });
    };

    const uploadItemsClickHandler = () => {
        setUploadItemsModalIsOpen(true);
    };

    const uploadItemsModalCloseHandler = () => {
        setUploadItemsModalIsOpen(false);
    };

    const uploadProductsHandler = async (products: ProductDto[]) => {
        const productInfos = products.map(o => ({
            productId: o.id,
            qtyOrdered: o.qtyOrdered,
            unitOfMeasure: o.selectedUnitOfMeasure ?? "",
        }));
        await addToWishList({ productInfos, selectedWishList: wishList });
        setUploadItemsModalIsOpen(false);
        loadWishListIfNeeded({ wishListId: wishList.id });
    };

    const canEditWishList = (wishList.allowEdit || !wishList.isSharedList) && !wishList.isAutogenerated;

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* Starter Custom Code - Start */}
            {canEditWishList && (
                <>
                    <Accordion headingLevel={2} {...styles.addItemsAccordion}>
                        <AccordionSection
                            title={translate("Add Items To List")}
                            expanded={addItemsToListIsOpen}
                            onTogglePanel={addItemsToListClickHandler}
                        >
                            <Link
                                {...styles.uploadItemsLink}
                                onClick={uploadItemsClickHandler}
                                data-test-selector="myListDetails_uploadItems"
                            >
                                {translate("Upload Items")}
                            </Link>
                            <ProductSelector
                                selectButtonTitle={translate("Add to List")}
                                skipInventoryValidation={true}
                                denyFixedConfiguration={true}
                                onSelectProduct={selectProductHandler}
                                productIsConfigurableMessage={siteMessage("ListUpload_CannotOrderConfigurable")}
                                productIsUnavailableMessage={siteMessage("Product_NotFound")}
                                extendedStyles={styles.productSelectorStyles}
                            />
                        </AccordionSection>
                    </Accordion>
                    <Modal
                        {...styles.uploadItemsModal}
                        headline={translate("Upload Items To List")}
                        isOpen={uploadItemsModalIsOpen}
                        handleClose={uploadItemsModalCloseHandler}
                        data-test-selector="myListDetails_uploadItemsToListModal"
                    >
                        <GridContainer>
                            {/* bunzl custom code added styles */}
                            <GridItem {...styles.orderUploadGridItem}>
                                <OrderUpload
                                    descriptionText={siteMessage("Lists_UploadLinkTooltip")}
                                    checkInventory={false}
                                    templateUrl="/Excel/ListUploadTemplate.xlsx"
                                    onUploadProducts={uploadProductsHandler}
                                    extendedStyles={styles.orderUploadStyles}
                                />
                                <OrderUploadErrorsModal
                                    descriptionText={siteMessage("ListUpload_UploadError")}
                                    uploadErrorText={siteMessage("ListUpload_UploadError")}
                                    rowsLimitExceededText={siteMessage("ListUpload_RowsLimitExceeded")}
                                    errorReasons={{
                                        [UploadError.ConfigurableProduct]: siteMessage(
                                            "ListUpload_CannotOrderConfigurable",
                                        ),
                                        [UploadError.StyledProduct]: siteMessage("ListUpload_CannotOrderStyled"),
                                        [UploadError.InvalidUnit]: translate("Invalid U/M"),
                                        [UploadError.NotFound]: siteMessage("Product_NotFound"),
                                    }}
                                    extendedStyles={styles.orderUploadErrorsModalStyles}
                                />
                            </GridItem>
                            <GridItem width={[12, 12, 6, 6, 6]}>
                                <Zone zoneName="UploadInstructions" contentId={id} />
                            </GridItem>
                        </GridContainer>
                    </Modal>
                </>
            )}
            <CardListHeading heading={translate("My List")} hasNoResults>
                {wishListLinesDataView.value &&
                wishListLinesDataView.pagination?.sortOptions &&
                !wishList.isAutogenerated ? (
                    <StyledWrapper {...styles.sortByWrapper} data-test-selector="myListDetailPage_ProductsSortBy">
                        <SelectInline
                            label={`${translate("Sort by")}${translate(":")}`}
                            labelPosition="left"
                            uid="myLists_sort"
                            value={loadWishListLinesParameter.sort}
                            extendedStyles={styles.sortBySelectInline}
                            onChange={event => sortByChangeHandler(event.currentTarget.value)}
                        >
                            {wishListLinesDataView.value &&
                                wishListLinesDataView.pagination?.sortOptions?.map(sortOption => (
                                    <option value={sortOption.sortType} key={sortOption.sortType}>
                                        {sortOption.displayName}
                                    </option>
                                ))}
                        </SelectInline>
                    </StyledWrapper>
                ) : null}
            </CardListHeading>
            <GridContainer {...styles.container}>
                <GridItem {...styles.searchGridItem}>
                    <TextField
                        {...styles.search}
                        placeholder={translate("Type to search")}
                        value={query}
                        onChange={searchChangeHandler}
                        data-test-selector="wishListSearch"
                        label={translate("Search within list")}
                        type="search"
                    />
                </GridItem>
            </GridContainer>
            {/* Starter Custom Code - End */}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyListsDetailsOptions),
    definition: {
        group: "My Lists Details",
        displayName: "Options",
        allowedContexts: ["MyListsDetailsPage"],
    },
};

export default widgetModule;
